import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { format } from 'date-fns';
import { AssignmentWithStudentSubmissionEntity } from '../../../../../../../../api/types/students/assignments/student-assignments';

interface AssignmentsTableProps {
  assignments: AssignmentWithStudentSubmissionEntity[];
}

export const AssignmentsTable: React.FC<AssignmentsTableProps> = ({
  assignments,
}) => {
  // Assignment template functions
  const assignmentStatusTemplate = (
    assignment: AssignmentWithStudentSubmissionEntity,
  ) => {
    const getStatusText = (status: any) => {
      switch (status) {
        case 0: // OPEN_TO_SUBMIT
          return 'פתוח להגשה';
        case 1: // CLOSE_TO_SUBMIT
          return 'סגור להגשה';
        default:
          return 'לא ידוע';
      }
    };

    const getStatusSeverity = (status: any) => {
      switch (status) {
        case 0: // OPEN_TO_SUBMIT
          return 'success';
        case 1: // CLOSE_TO_SUBMIT
          return 'danger';
        default:
          return 'secondary';
      }
    };

    return (
      <Tag
        value={getStatusText(assignment.status)}
        severity={getStatusSeverity(assignment.status)}
      />
    );
  };

  const assignmentGradeTemplate = (
    assignment: AssignmentWithStudentSubmissionEntity,
  ) => {
    if (assignment.grade !== undefined && assignment.grade !== null) {
      return <span className="grade-value">{assignment.grade}</span>;
    }
    return '-';
  };

  const assignmentDueDateTemplate = (
    assignment: AssignmentWithStudentSubmissionEntity,
  ) => {
    const dueDate = assignment.customDueDate || assignment.dueDate;
    if (!dueDate) return '-';
    return format(new Date(dueDate), 'dd/MM/yyyy');
  };

  const assignmentSubmissionTemplate = (
    assignment: AssignmentWithStudentSubmissionEntity,
  ) => {
    if (assignment.submittedAt) {
      return <Tag value="הוגש" severity="success" icon="pi pi-check" />;
    }
    return <Tag value="לא הוגש" severity="danger" icon="pi pi-times" />;
  };

  return (
    <div className="dialog-assignments">
      <h3>מטלות</h3>
      <DataTable
        value={assignments || []}
        className="assignments-table"
        responsiveLayout="stack"
        breakpoint="768px"
        showGridlines
        dir="rtl"
        emptyMessage="לא נמצאו מטלות"
      >
        <Column field="assignmentName" header="שם המטלה" sortable />
        <Column
          field="dueDate"
          header="תאריך הגשה"
          body={(rowData) => assignmentDueDateTemplate(rowData)}
          sortable
        />
        <Column
          field="assignmentWeight"
          header="משקל"
          body={(rowData) => `${rowData.assignmentWeight}%`}
          sortable
          dataType="numeric"
        />
        <Column
          field="grade"
          header="ציון"
          body={(rowData) => assignmentGradeTemplate(rowData)}
          sortable
          dataType="numeric"
        />
        <Column
          field="submittedAt"
          header="סטטוס הגשה"
          body={(rowData) => assignmentSubmissionTemplate(rowData)}
          sortable
        />
      </DataTable>
    </div>
  );
};
